<template>
    <div>
        <div class="col-12 lg:col-12 px-0">
        <Toolbar class="mb-2">
            <template #end>
            <Button
                label="Nuevo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="agregarLinea"
            />
            </template>
        </Toolbar>
        </div>

        <DataTable
        :value="lstLineas"
        dataKey="Id_tipo_linea"
        ref="dt"
        v-model:filters="filters"
        :globalFilterFields="['Descripcion']"
        :loading="loading"
        :paginator="true"
        :rows="20"
        responsiveLayout="scroll"
        >
        <template #header>
            <div class="table-header">
            <h5>Tipos de lineas</h5>
            <span>Número de lineas {{ lstLineas ? lstLineas.length : 0 }}</span>
            <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                type="text"
                v-model="filters['global'].value"
                placeholder="Buscar..."
                />
            </span>
            </div>
        </template>
        <template #empty> No se encontrarón registros. </template>
        <template #loading> Cargando datos. Espere por favor. </template>
        <Column field="Descripcion" header="SERVCIO" sortable>
            <template #body="{data}"> {{ data.Descripcion }}</template>
        </Column>
        <Column field="Activo" header="ESTATUS" sortable>
            <template #body="slotProps">
            <span class="status-activo" v-show="slotProps.data.Estatus == true"> ACTIVO </span>
            <span class="status-inactivo" v-show="slotProps.data.Estatus == false"> INACTIVO </span>
            </template>
        </Column>
        <Column :exportable="false">
            <template #body="slotProps">
            <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="edit(slotProps.data)"
            />
            <Button
                style="margin-left: 8px"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger"
                @click="borrar(slotProps.data)"
            />
            </template>
        </Column>
        <template #footer>
            Registros en total {{ lstLineas ? lstLineas.length : 0 }}
        </template>
        </DataTable>

        <Dialog :style="{ width: '600px' }" :visible="showAgregar" :modal="true" class="p-fluid" :closable="false">
            <template #header>
                <h3>{{ modoEdicion }} linea</h3>
            </template>

            <div class="p-formgrid grid">
                <div class="p-field col">
                <label for="Linea">Linea</label>
                <InputText
                    autocomplete="off"
                    id="Producto"
                    v-model.trim="linea.Descripcion"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !linea.Descripcion }"
                />
                <small class="p-invalid" v-if="submitted && !linea.Descripcion">El linea es requerido.</small>
                </div>
            </div>

            <div class="p-formgrid grid">
                <div class="p-field col">
                <div class="p-field-checkbox">
                    <Checkbox
                    id="Activo"
                    name="Activo"
                    :binary="true"
                    v-model="linea.Activo"
                    />
                    <label for="Activo"> Activo</label>
                </div>
                </div>
            </div>

            <template #footer>
                <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="cancelarDialogo"
                />
                <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                id="btnGuardar"
                @click="guardarLinea"
                />
            </template>
        </Dialog>
        <ConfirmDialog></ConfirmDialog>
    </div>
</template>
  
<script>
import SCatalogos from "../service/Tipos_lineas";
import { FilterMatchMode } from "primevue/api";
import { ConfirmDialog } from 'primevue/confirmdialog';
import {mapGetters} from 'vuex';

export default {
    components: {
        ConfirmDialog
    },
    data() {
        return {
            Activo: false,
            Capitalizable: false,
            Salida_individual: false,
            lstUnidades: [],
            selectedUnidadFiltro: null,
            lstLineas: null,
            lstLineasO: null,
            lstTipos: null,
            lstModalidades: null,
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            filter: null,
            loading: true,
            submitted: false,
            showAgregar: false,
            dispositivoEdited: null,
            modoEdicion: "",
            linea: {},
            img: "",
            mensajes:"",
            usuario: {},
            lstEstatus: [],
        };
    },
    created() {
        this.getLineas();
    },
    methods: {
        getLineas() {
            var t = this;
            var CSrvr = new SCatalogos();
            t.loading = true;

            CSrvr.getLineas(t)
                .then((res) => {
                    t.lstLineas = res;
                    t.loading = false;
                })
                .catch(function (error) {
                    console.error("Error:", error);
                    t.loading = false;
                });
        },
        collapseAll() {
            this.expandedRows = null;
        },
        forzarUpdate() {
            this.$forceUpdate();
        },
        agregarLinea() {
            var t = this;
            t.loading = true;

            this.submitted = false;
            this.showAgregar = true;
            this.modoEdicion = "Agregar";
            this.mensajes = "";
            this.linea.Activo = false;
        },
        cancelarDialogo() {
            this.submitted = false;
            this.showAgregar = false;
            this.modoEdicion = "";
            this.linea = {};
            this.mensajes = "";
        },
        edit(obj) {
            var t = this;
            t.loading = true;

            this.linea = { ...obj };
            this.showAgregar = true;
            this.modoEdicion = "Editar";
            if(obj.Estatus == true){
                this.linea.Activo = true;
            }
        },
        borrar(obj) {
            var t = this;      
            t.$confirm.require({
                message: '¿Quiere desactivar el linea?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sí, eliminar',
                rejectLabel: 'Cancelar',
                acceptClass: 'p-button-danger',
                accept: () => {
                    var val = obj;
                    var ctlSvr = new SCatalogos();

                    t.loading = false;

                    obj.Activo = false;
                    obj.Estatus = false;
                    
                    ctlSvr.updateLinea(t, val).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo eliminado correctamente",
                            life: 3000,
                        });
                        t.getLineas();
                    });
                },
                reject: () => {
                    // Acción al rechazar
                }
            });
        },
        guardarLinea() {
            var t = this;
            this.submitted = true;

            if (!t.linea || !t.linea.Descripcion) {
                t.mensajes = "Algunos campos faltantes son obligatorios";
                return;
            }

            if (t.linea.Activo == false) {
                t.linea.Estatus = false;
            } else {
                t.linea.Estatus = true;
            }

            this.sendRequest(t, t.linea);
        },
        sendRequest(t, obj) {
            var CSrvr = new SCatalogos();
            if (t.modoEdicion == "Agregar") {
                CSrvr.addLinea(t, obj).then(() => {
                    t.$toast.add({
                        severity: "success",
                        summary: "AVISO",
                        detail: "Insumo agregado correctamente",
                        life: 3000,
                    });
                    t.cancelarDialogo();
                    t.getLineas();
                });
            } else {
                if (obj.Activo == false) {
                    CSrvr.updateLinea(t, obj).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo editado correctamente",
                            life: 3000,
                        });
                        t.cancelarDialogo();
                        t.getLineas();
                    });
                } else{
                    CSrvr.updateLinea(t, obj).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo editado correctamente",
                            life: 3000,
                        });
                        t.cancelarDialogo();
                        t.getLineas();
                    });
                }
            }
        }
    },
    computed: {
        ...mapGetters(['getUrlLineas','getUsuarioLogueado']),  
    }       
};
</script>
  
<style scoped>
.table-header {
display: flex;
justify-content: space-between;
-webkit-box-pack: justify;
}
.title {
font-weight: 700;
letter-spacing: 0.3px;
margin-right: 10px;
text-transform: uppercase;
}
.data {
letter-spacing: 0.3px;
margin-right: 10px;
letter-spacing: 0.5px;
}
.product-image {
width: 100px;
}
</style>
  